<template>
	<svg v-if="id">
		<use :href="`${svgSprite}#${id}`" />
	</svg>
</template>

<script>
import svgSprite from '@/assets/landing/images/svg-sprite.svg'

export default {
	name: 'SvgIcon',
	props: {
		id: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			svgSprite
		}
	}
}
</script>
